import { MediaType } from "@/modules/common/media/mediaTypes"
import { word } from "@modules/core/utils/i18n"
import { has } from "lodash"
import * as Yup from "yup"
import { z } from "zod"

export const mediaItemFormSchema = z
  .object({
    url: z.string().nullable(),
    key: z.string().nullable(),
    file: z.custom<File>().nullable(),
    type: z.enum(MediaType),
    isUploading: z.boolean(),
    filename: z.string().nullable(),
  })
  .meta({
    id: "mediaItemFormSchema",
  })

export type MediaItemFormType = z.infer<typeof mediaItemFormSchema>

export function getMediaItemValidationSchema() {
  return Yup.object()
    .shape({
      url: Yup.string().nullable(),
      file: Yup.mixed().nullable(),
    })
    .test(
      "Youtube URL or Video File",
      word("sessionForm.blocks.add_media.missing_error"),
      (value) => has(value, "url") || has(value, "file"),
    )
}
